import { boot } from 'quasar/wrappers'

// Load the .nbme.theme-light / .theme-dark / .theme-sepia CSS-custom-property PROVIDERS app-wide.
// Previously this file was @imported ONLY by the quiz page (qbanktestinterfacePage.vue), so on
// every other page `.nbme.theme-dark` was present-but-empty (var(--background) resolved to nothing).
// The rules are scoped under `.nbme.theme-*`, so this import is completely INERT until an ancestor
// carries the class — zero visual change to any current (light) page.
import '../pages/qtiThemeVariables.css'

// The app theme value itself is a module singleton seeded synchronously from localStorage at import
// time — see src/composables/useGlobalTheme.js. Importing it here guarantees the singleton is
// initialised before the first component renders (no light flash on reload for returning users).
import '../composables/useGlobalTheme'

export default boot(() => {
  // No runtime work needed — the imports above are the whole job (global CSS provider + singleton init).
})
